(function () {

    angular
        .module('app')
        .controller('TeacherClassroomController', TeacherClassroomController);

    TeacherClassroomController.$inject = [
        'authService',
        'usersService',
        'classroomService',
        'loggerService',
        '$window',
        '$timeout'
    ];

    function TeacherClassroomController(authService, usersService, classroomService, loggerService, $window, $timeout) {

        var vm = this;
        vm.authService = authService;

        vm.busy = true;
        vm.errors = [];
        vm.notices = [];
        vm.groupedStudents = [];
        vm.joinedStudents = [];
        vm.assignments = [];
        vm.savedAllocations = [];
        vm.selectedStudents = {};
        vm.studentDirectoryFallback = false;
        vm.purchaseAmount = 10000;
        vm.purchaseBusy = false;
        vm.quotaSaving = false;
        vm.dispatchBusy = false;
        vm.submissionsBusy = false;
        vm.usageBusy = false;
        vm.reviewBusy = {};
        vm.submissionFilter = 'all';
        vm.submissionAssignmentFilter = 'all';

        vm.classroomCode = {
            sessionId : '',
            code : 'QITAN-' + Math.random().toString(36).slice(2, 8).toUpperCase(),
            expiresIn : '本节课有效',
            mode : '学生登录后输入验证码加入教室'
        };

        vm.tokenWallet = {
            total : 120000,
            reserved : 15000,
            assigned : 0
        };

        vm.modelAbilities = [
            { id : 'text', name : '文本问答', unit : 'tokens', enabled : true, defaultQuota : 3000 },
            { id : 'image', name : 'AI 生图', unit : 'credits', enabled : true, defaultQuota : 20 },
            { id : 'vision', name : '图片理解', unit : 'tokens', enabled : true, defaultQuota : 1500 },
            { id : 'tts', name : '语音合成', unit : 'characters', enabled : true, defaultQuota : 3000 },
            { id : '3d', name : '3D 建模', unit : 'credits', enabled : false, defaultQuota : 5 },
            { id : 'robotics', name : '具身智能', unit : 'credits', enabled : false, defaultQuota : 5 }
        ];

        vm.contentPacks = [
            { id : 'scratch-demo', title : 'Scratch AI 互动模板', type : 'Scratch 项目', selected : true },
            { id : 'media-prompt', title : 'AI 多媒体提示词卡', type : '课程素材', selected : false },
            { id : 'python-agent', title : 'AI 编程任务模板', type : '代码项目', selected : false },
            { id : 'hardware-lab', title : '智能硬件实验记录表', type : '实验任务', selected : false }
        ];

        vm.quotaTemplates = [
            {
                id : 'scratch',
                title : 'Scratch 启蒙课',
                summary : '适合低龄互动项目，保留文本、生图和图片理解，避免额度过散。',
                quota : { text : 1500, image : 10, vision : 500, tts : 0, threeD : 0, robotics : 0 }
            },
            {
                id : 'media-3d',
                title : 'AI 多媒体与 3D',
                summary : '适合图像、语音、3D 打印前置设计，额度向创作型能力倾斜。',
                quota : { text : 2000, image : 30, vision : 2000, tts : 5000, threeD : 8, robotics : 0 }
            },
            {
                id : 'coding',
                title : 'AI 编程课',
                summary : '适合代码解释、调试和项目生成，重点保留文本推理与图片理解。',
                quota : { text : 5000, image : 0, vision : 1000, tts : 0, threeD : 0, robotics : 0 }
            },
            {
                id : 'hardware',
                title : '智能硬件与具身智能',
                summary : '适合传感器、视觉识别和机器人任务，预留具身智能实验额度。',
                quota : { text : 3000, image : 0, vision : 1500, tts : 0, threeD : 0, robotics : 8 }
            }
        ];

        vm.submissions = [];
        vm.usageLedger = [];

        vm.storagePolicy = {
            cloud : true,
            teacherBrowser : true,
            studentExport : true,
            reviewBeforePublish : true
        };

        function addNotice(message) {
            vm.notices.unshift({
                message : message,
                at : new Date()
            });
        }

        vm.getClassroomJoinUrl = function () {
            return $window.location.origin + $window.location.pathname + '#!/classroom/join';
        };

        vm.getClassroomShareText = function () {
            return '学生加入课堂入口：' + vm.getClassroomJoinUrl() + '\n课堂验证码：' + vm.classroomCode.code;
        };

        function fallbackCopy(text) {
            var textarea = $window.document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', 'readonly');
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            $window.document.body.appendChild(textarea);
            textarea.select();

            try {
                var copied = $window.document.execCommand('copy');
                addNotice(copied ? '已复制学生课堂入口和验证码。' : '浏览器不允许自动复制，请手动复制入口和验证码。');
            }
            catch (err) {
                loggerService.error('[teacher-classroom] copy failed', err);
                addNotice('浏览器不允许自动复制，请手动复制入口和验证码。');
            }
            finally {
                $window.document.body.removeChild(textarea);
            }
        }

        vm.copyClassroomJoinDetails = function () {
            var text = vm.getClassroomShareText();
            if ($window.navigator &&
                $window.navigator.clipboard &&
                $window.navigator.clipboard.writeText) {
                $window.navigator.clipboard.writeText(text)
                    .then(function () {
                        $timeout(function () {
                            addNotice('已复制学生课堂入口和验证码。');
                        });
                    })
                    .catch(function () {
                        $timeout(function () {
                            fallbackCopy(text);
                        });
                    });
                return;
            }

            fallbackCopy(text);
        };

        function friendlyError(err, fallback) {
            var message = (err && err.data && (err.data.error || err.data.message)) ||
                          (err && err.message);
            var known = {
                'AI quota is not enough' : '可用额度不足，请重新分配学生额度。',
                'Missing AI usage target' : '请选择要使用的 AI 能力。',
                'AI usage amount must be greater than zero' : '使用额度必须大于 0。',
                '购买额度必须大于 0' : '购买额度必须大于 0。',
                '请提供额度分配方案' : '请先选择学生并设置额度。',
                '请提供有效的额度分配方案' : '额度分配里有无效学生、能力或数值，请检查后再保存。',
                '请填写下发任务标题' : '请先选择要下发的课堂内容。',
                '请输入作品名称' : '作品名称不能为空。',
                '可用额度不足，请联系老师重新分配' : '可用额度不足，请重新分配学生额度。',
                '老师还没有为你分配这个 AI 能力' : '还没有给学生分配这个 AI 能力。'
            };
            return known[message] || message || fallback;
        }

        function showError(err) {
            loggerService.error('[teacher-classroom] failed', err);
            vm.errors.push({
                status : err && err.status,
                message : friendlyError(err, '教室数据读取失败')
            });
        }

        function quotaFieldForAbility(abilityId) {
            return abilityId === '3d' ? 'threeD' : abilityId;
        }

        function getStudentId(student) {
            return student && (student.id || student.user_id || student.studentid || student.username);
        }

        function summarizeAssignedQuota() {
            var assigned = 0;
            vm.groupedStudents.forEach(function (student) {
                if (!student.quota) {
                    return;
                }
                assigned += Number(student.quota.text) || 0;
                assigned += Number(student.quota.vision) || 0;
                assigned += Number(student.quota.tts) || 0;
            });
            vm.tokenWallet.assigned = assigned;
        }

        vm.summarizeAssignedQuota = summarizeAssignedQuota;

        function applySession(session) {
            if (!session) {
                return;
            }
            vm.classroomCode.sessionId = session.id;
            vm.classroomCode.code = session.joinCode || vm.classroomCode.code;
            vm.classroomCode.expiresIn = session.joinCodeExpiresAt ?
                '有效至 ' + new Date(session.joinCodeExpiresAt).toLocaleTimeString() :
                vm.classroomCode.expiresIn;
        }

        function applyWallet(wallet) {
            if (!wallet) {
                return;
            }
            vm.tokenWallet.total = wallet.total;
            vm.tokenWallet.reserved = wallet.reserved;
            vm.tokenWallet.assigned = wallet.assigned;
        }

        function decorateStudent(student) {
            student.id = getStudentId(student);
            student.quota = {
                text : 3000,
                image : 20,
                vision : 1500,
                tts : 3000,
                threeD : 0,
                robotics : 0
            };
            student.enabledAbilities = {
                text : true,
                image : true,
                vision : true,
                tts : true,
                threeD : false,
                robotics : false
            };
            return student;
        }

        function applyAllocationToStudent(student, allocation) {
            var field = quotaFieldForAbility(allocation.abilityId);
            if (!student.quota || typeof student.quota[field] === 'undefined') {
                return;
            }
            student.quota[field] = allocation.quota;
            if (student.enabledAbilities) {
                student.enabledAbilities[field] = allocation.quota > 0;
            }
        }

        function applySavedAllocations() {
            vm.groupedStudents.forEach(function (student) {
                vm.savedAllocations
                    .filter(function (allocation) {
                        return allocation.studentId === getStudentId(student);
                    })
                    .forEach(function (allocation) {
                        applyAllocationToStudent(student, allocation);
                    });
            });
            summarizeAssignedQuota();
        }

        function ensureJoinedStudentsInGroup() {
            vm.joinedStudents.forEach(function (joinedStudent) {
                var id = joinedStudent.studentid;
                var exists = vm.groupedStudents.some(function (student) {
                    return getStudentId(student) === id;
                });
                if (!exists) {
                    vm.groupedStudents.push(decorateStudent({
                        id : id,
                        user_id : id,
                        username : '已加入课堂学生 ' + id.slice(0, 8),
                        source : 'classroom'
                    }));
                }
            });
            applySavedAllocations();
        }

        function useJoinedStudentsFallback(err) {
            if (err) {
                loggerService.error('[teacher-classroom] student directory fallback', err);
            }
            var shouldNotify = !vm.studentDirectoryFallback;
            vm.studentDirectoryFallback = true;
            vm.groupedStudents = [];
            ensureJoinedStudentsInGroup();
            summarizeAssignedQuota();

            if (shouldNotify) {
                addNotice('当前环境没有连接学生账号目录，已改用“课堂码加入名单”管理学生。');
            }
        }

        function selectedStudentIds() {
            return Object.keys(vm.selectedStudents).filter(function (id) {
                return vm.selectedStudents[id];
            });
        }

        function selectedOrAllStudents() {
            var selectedIds = selectedStudentIds();
            if (!selectedIds.length) {
                return vm.groupedStudents;
            }
            return vm.groupedStudents.filter(function (student) {
                return selectedIds.indexOf(getStudentId(student)) !== -1;
            });
        }

        function applyQuotaToStudents(students, quota) {
            students.forEach(function (student) {
                Object.keys(quota).forEach(function (field) {
                    if (!student.quota || typeof student.quota[field] === 'undefined') {
                        return;
                    }
                    student.quota[field] = quota[field];
                    student.enabledAbilities[field] = quota[field] > 0;
                });
            });
        }

        function updateAbilityDefaults(quota) {
            vm.modelAbilities.forEach(function (ability) {
                var field = quotaFieldForAbility(ability.id);
                ability.defaultQuota = quota[field];
                ability.enabled = quota[field] > 0;
            });
        }

        function buildAllocationPayload(students) {
            var allocations = [];

            students.forEach(function (student) {
                var studentId = getStudentId(student);
                vm.modelAbilities.forEach(function (ability) {
                    var field = quotaFieldForAbility(ability.id);
                    allocations.push({
                        studentId : studentId,
                        abilityId : ability.id,
                        quota : Number(student.quota[field]) || 0,
                        unit : ability.unit
                    });
                });
            });

            return allocations;
        }

        function getStudentName(studentid) {
            var match = vm.groupedStudents.filter(function (student) {
                return getStudentId(student) === studentid;
            })[0];
            return match ? match.username : studentid;
        }

        vm.getStudentName = getStudentName;

        function prepareSubmissions(submissions) {
            vm.submissions = (submissions || []).map(function (submission) {
                submission.reviewNoteDraft = submission.reviewNote || '';
                return submission;
            });
        }

        function loadSubmissions(showNotice) {
            if (!vm.classroomCode.sessionId) {
                vm.submissions = [];
                return;
            }

            vm.submissionsBusy = true;
            classroomService.getSubmissions(vm.profile, vm.profile.tenant, vm.classroomCode.sessionId)
                .then(function (submissions) {
                    prepareSubmissions(submissions);
                    if (showNotice) {
                        addNotice('已刷新作品回收区。');
                    }
                })
                .catch(showError)
                .finally(function () {
                    vm.submissionsBusy = false;
                });
        }

        vm.getUnitLabel = function (unit) {
            var labels = {
                tokens : '令牌',
                credits : '点数',
                characters : '字符'
            };
            return labels[unit] || unit || '';
        };

        vm.getAbilityName = function (abilityId) {
            var match = vm.modelAbilities.filter(function (ability) {
                return ability.id === abilityId;
            })[0];
            return match ? match.name : abilityId;
        };

        vm.getSubmissionStatusLabel = function (status) {
            var labels = {
                submitted : '已提交',
                reviewed : '已批阅',
                returned : '已退回'
            };
            return labels[status] || status || '未收到';
        };

        vm.reviewedSubmissionCount = function () {
            return vm.submissions.filter(function (submission) {
                return submission.status === 'reviewed';
            }).length;
        };

        vm.pendingSubmissionCount = function () {
            return vm.submissions.filter(function (submission) {
                return submission.status === 'submitted';
            }).length;
        };

        vm.getStorageLabel = function (storage) {
            var labels = {
                cloud : '云端作品库',
                'object-store' : '开源对象存储',
                'database-fallback' : '课堂本地兜底',
                'teacher-browser' : '教师本地浏览器',
                'student-export' : '学生导出包'
            };
            return labels[storage] || storage || '未设置';
        };

        vm.getAssignmentTargetLabel = function (assignment) {
            if (!assignment || !assignment.studentIds || !assignment.studentIds.length) {
                return '全班学生';
            }
            return assignment.studentIds.length + ' 名指定学生';
        };

        vm.getAssignmentTitle = function (assignmentId) {
            if (!assignmentId) {
                return '未关联课堂任务';
            }
            var match = vm.assignments.filter(function (assignment) {
                return assignment.id === assignmentId;
            })[0];
            return match ? match.title : '已下发任务';
        };

        function uniqueStudents(students) {
            var seen = {};
            return students.filter(function (student) {
                var studentId = getStudentId(student);
                if (!studentId || seen[studentId]) {
                    return false;
                }
                seen[studentId] = true;
                return true;
            });
        }

        function joinedStudentAsDirectoryStudent(joinedStudent) {
            return {
                id : joinedStudent.studentid,
                user_id : joinedStudent.studentid,
                username : getStudentName(joinedStudent.studentid)
            };
        }

        function getAssignmentById(assignmentId) {
            return vm.assignments.filter(function (assignment) {
                return assignment.id === assignmentId;
            })[0];
        }

        function getAssignmentTargetStudents(assignment) {
            if (!assignment) {
                return [];
            }
            if (assignment.studentIds && assignment.studentIds.length) {
                return uniqueStudents(assignment.studentIds.map(function (studentId) {
                    return {
                        id : studentId,
                        user_id : studentId,
                        username : getStudentName(studentId)
                    };
                }));
            }

            if (vm.groupedStudents.length) {
                return uniqueStudents(vm.groupedStudents);
            }

            return uniqueStudents(vm.joinedStudents.map(joinedStudentAsDirectoryStudent));
        }

        function getSubmissionsForAssignment(assignmentId) {
            return vm.submissions.filter(function (submission) {
                return submission.assignmentId === assignmentId;
            });
        }

        function getSubmittedStudentIds(assignmentId) {
            var submitted = {};
            getSubmissionsForAssignment(assignmentId).forEach(function (submission) {
                submitted[submission.owner] = true;
            });
            return submitted;
        }

        vm.getAssignmentSubmissionSummary = function (assignment) {
            var targetStudents = getAssignmentTargetStudents(assignment);
            var submittedStudentIds = getSubmittedStudentIds(assignment && assignment.id);
            var submittedCount = targetStudents.filter(function (student) {
                return submittedStudentIds[getStudentId(student)];
            }).length;

            return {
                targetCount : targetStudents.length,
                submittedCount : submittedCount,
                missingCount : Math.max(targetStudents.length - submittedCount, 0)
            };
        };

        vm.getSelectedAssignment = function () {
            if (vm.submissionAssignmentFilter === 'all' ||
                vm.submissionAssignmentFilter === 'unassigned') {
                return undefined;
            }
            return getAssignmentById(vm.submissionAssignmentFilter);
        };

        vm.getSubmittedStudentsForSelectedAssignment = function () {
            var assignment = vm.getSelectedAssignment();
            if (!assignment) {
                return [];
            }
            var submittedStudentIds = getSubmittedStudentIds(assignment.id);
            return getAssignmentTargetStudents(assignment).filter(function (student) {
                return submittedStudentIds[getStudentId(student)];
            });
        };

        vm.getMissingStudentsForSelectedAssignment = function () {
            var assignment = vm.getSelectedAssignment();
            if (!assignment) {
                return [];
            }
            var submittedStudentIds = getSubmittedStudentIds(assignment.id);
            return getAssignmentTargetStudents(assignment).filter(function (student) {
                return !submittedStudentIds[getStudentId(student)];
            });
        };

        function loadJoinedStudents() {
            if (!vm.classroomCode.sessionId) {
                vm.joinedStudents = [];
                return;
            }

            classroomService.getJoinedStudents(vm.profile, vm.classroomCode.sessionId)
                .then(function (students) {
                    vm.joinedStudents = students;
                    ensureJoinedStudentsInGroup();
                })
                .catch(function (err) {
                    loggerService.error('[teacher-classroom] joined students fallback', err);
                });
        }

        function loadAssignments() {
            if (!vm.classroomCode.sessionId) {
                vm.assignments = [];
                return;
            }

            classroomService.getAssignments(vm.profile, vm.profile.tenant, vm.classroomCode.sessionId)
                .then(function (assignments) {
                    vm.assignments = assignments;
                })
                .catch(function (err) {
                    loggerService.error('[teacher-classroom] assignments fallback', err);
                });
        }

        function loadUsage(showNotice) {
            vm.usageBusy = true;
            classroomService.getUsage(vm.profile)
                .then(function (usageLedger) {
                    vm.usageLedger = usageLedger || [];
                    if (showNotice) {
                        addNotice('已刷新 AI 使用流水。');
                    }
                })
                .catch(function (err) {
                    loggerService.error('[teacher-classroom] usage fallback', err);
                    vm.usageLedger = [];
                })
                .finally(function () {
                    vm.usageBusy = false;
                });
        }

        function loadClassroomOps() {
            classroomService.getCurrentSession(vm.profile)
                .then(function (session) {
                    applySession(session);
                    loadJoinedStudents();
                    loadAssignments();
                    loadSubmissions(false);
                    loadUsage(false);
                })
                .catch(function (err) {
                    loggerService.error('[teacher-classroom] session fallback', err);
                });

            classroomService.getWallet(vm.profile)
                .then(applyWallet)
                .catch(function (err) {
                    loggerService.error('[teacher-classroom] wallet fallback', err);
                });

            classroomService.getAllocations(vm.profile)
                .then(function (result) {
                    applyWallet(result.wallet);
                    vm.savedAllocations = result.allocations || [];
                    applySavedAllocations();
                })
                .catch(function (err) {
                    loggerService.error('[teacher-classroom] allocations fallback', err);
                });
        }

        function loadStudentsForGroup(group) {
            if (!group) {
                vm.activeGroup = '';
                useJoinedStudentsFallback();
                vm.busy = false;
                return;
            }

            vm.busy = true;
            if (typeof OIDC_LOGIN_ENABLED !== 'undefined' && OIDC_LOGIN_ENABLED) {
                vm.activeGroup = group;
                useJoinedStudentsFallback();
                vm.busy = false;
                return;
            }

            usersService.getStudentList(vm.profile, group)
                .then(function (students) {
                    vm.studentDirectoryFallback = false;
                    vm.groupedStudents = students.map(decorateStudent);
                    vm.activeGroup = group;
                    ensureJoinedStudentsInGroup();
                })
                .catch(useJoinedStudentsFallback)
                .finally(function () {
                    vm.busy = false;
                });
        }

        authService.getProfileDeferred()
            .then(function (profile) {
                vm.profile = profile;
                if (profile.role !== 'supervisor') {
                    vm.busy = false;
                    return;
                }

                if (!profile.groups) {
                    profile.groups = [];
                }

                return usersService.getClassPolicy(profile)
                    .then(function (policy) {
                        vm.policy = policy;
                    })
                    .catch(function (err) {
                        loggerService.error('[teacher-classroom] class policy fallback', err);
                        vm.policy = {
                            isManaged : true,
                            missingCredentials : false
                        };
                        addNotice('班级策略暂时不可用，已先进入教室运营台。');
                    })
                    .finally(function () {
                        vm.activeGroup = profile.groups[0] || '';
                        loadClassroomOps();
                        loadStudentsForGroup(vm.activeGroup);
                    });
            })
            .catch(showError)
            .finally(function () {
                if (!vm.profile || vm.profile.role !== 'supervisor') {
                    vm.busy = false;
                }
            });

        vm.refreshJoinCode = function () {
            if (!vm.classroomCode.sessionId) {
                vm.classroomCode.code = 'QITAN-' + Math.random().toString(36).slice(2, 8).toUpperCase();
                addNotice('已生成新的课堂验证码。后端未返回课堂 session 时，会先使用本地验证码。');
                return;
            }

            classroomService.refreshJoinCode(vm.profile, vm.classroomCode.sessionId)
                .then(function (session) {
                    applySession(session);
                    addNotice('已生成新的课堂验证码。');
                })
                .catch(showError);
        };

        vm.refreshJoinedStudents = function () {
            loadJoinedStudents();
            addNotice('已刷新加入课堂的学生名单。');
        };

        vm.refreshAssignments = function () {
            loadAssignments();
            addNotice('已刷新已下发任务。');
        };

        vm.loadGroup = function (group) {
            loadStudentsForGroup(group);
        };

        vm.applyDefaultQuota = function () {
            var targetStudents = selectedOrAllStudents();
            targetStudents.forEach(function (student) {
                vm.modelAbilities.forEach(function (ability) {
                    var field = quotaFieldForAbility(ability.id);
                    student.quota[field] = ability.enabled ? ability.defaultQuota : 0;
                    student.enabledAbilities[field] = ability.enabled;
                });
            });

            summarizeAssignedQuota();
            vm.saveAllocations('已按当前能力为 ' + targetStudents.length + ' 名学生保存额度。');
        };

        vm.applyQuotaTemplate = function (template) {
            if (!vm.groupedStudents.length) {
                addNotice('当前分组还没有学生，暂时不能套用课程模板。');
                return;
            }

            var targetStudents = selectedOrAllStudents();
            updateAbilityDefaults(template.quota);
            applyQuotaToStudents(targetStudents, template.quota);
            summarizeAssignedQuota();
            vm.saveAllocations('已套用“' + template.title + '”模板，并为 ' + targetStudents.length + ' 名学生保存额度。');
        };

        vm.saveAllocations = function (message) {
            if (!vm.groupedStudents.length) {
                addNotice('当前分组还没有学生，暂时不用保存额度。');
                return;
            }

            summarizeAssignedQuota();
            vm.quotaSaving = true;

            classroomService.updateAllocations(vm.profile, buildAllocationPayload(vm.groupedStudents)).then(function (result) {
                applyWallet(result.wallet);
                vm.savedAllocations = result.allocations || [];
                applySavedAllocations();
                addNotice(message || '已保存当前学生额度方案。');
            }).catch(showError)
            .finally(function () {
                vm.quotaSaving = false;
            });
        };

        vm.purchaseTokens = function () {
            var amount = Number(vm.purchaseAmount);
            if (!isFinite(amount) || amount <= 0) {
                addNotice('购买额度必须大于 0。');
                return;
            }

            vm.purchaseBusy = true;
            classroomService.purchaseTokens(vm.profile, amount)
                .then(function (wallet) {
                    applyWallet(wallet);
                    addNotice('已为教师额度池增加 ' + amount + ' 令牌。');
                })
                .catch(showError)
                .finally(function () {
                    vm.purchaseBusy = false;
                });
        };

        vm.toggleStudent = function (student) {
            var studentId = getStudentId(student);
            vm.selectedStudents[studentId] = !vm.selectedStudents[studentId];
        };

        vm.selectAllStudents = function () {
            vm.groupedStudents.forEach(function (student) {
                vm.selectedStudents[getStudentId(student)] = true;
            });
        };

        vm.selectJoinedStudents = function () {
            vm.selectedStudents = {};
            vm.joinedStudents.forEach(function (student) {
                vm.selectedStudents[student.studentid] = true;
            });
        };

        vm.clearSelectedStudents = function () {
            vm.selectedStudents = {};
        };

        vm.selectedCount = function () {
            return selectedStudentIds().length;
        };

        vm.targetStudentSummary = function () {
            var selectedCount = selectedStudentIds().length;
            return selectedCount ? selectedCount + ' 名已选学生' : '全班学生';
        };

        vm.hasSelectedContentPacks = function () {
            return vm.contentPacks.some(function (pack) {
                return pack.selected;
            });
        };

        vm.dispatchSelectedContent = function () {
            var selectedPacks = vm.contentPacks.filter(function (pack) {
                return pack.selected;
            });
            var packNames = selectedPacks.map(function (pack) {
                return pack.title;
            });

            if (!selectedPacks.length) {
                addNotice('请先勾选至少一个要下发的课程内容。');
                return;
            }
            if (!vm.classroomCode.sessionId) {
                addNotice('课堂还没有准备好，请稍后再下发内容。');
                return;
            }

            vm.dispatchBusy = true;
            classroomService.createAssignment(vm.profile, vm.classroomCode.sessionId, {
                title : packNames.join('、'),
                contentPackIds : selectedPacks.map(function (pack) {
                    return pack.id;
                }),
                studentIds : selectedStudentIds()
            }).then(function () {
                addNotice('已向' + vm.targetStudentSummary() + '创建课堂下发任务。');
                loadAssignments();
            }).catch(showError)
            .finally(function () {
                vm.dispatchBusy = false;
            });
        };

        vm.collectSubmissions = function () {
            loadSubmissions(true);
        };

        vm.refreshUsage = function () {
            loadUsage(true);
        };

        vm.filteredSubmissions = function () {
            return vm.submissions.filter(function (submission) {
                var statusMatch = vm.submissionFilter === 'all' ||
                    submission.status === vm.submissionFilter;
                var assignmentMatch = vm.submissionAssignmentFilter === 'all' ||
                    (vm.submissionAssignmentFilter === 'unassigned' && !submission.assignmentId) ||
                    submission.assignmentId === vm.submissionAssignmentFilter;
                return statusMatch && assignmentMatch;
            });
        };

        vm.reviewSubmission = function (submission, status) {
            if (!submission || !submission.id) {
                return;
            }

            vm.reviewBusy[submission.id] = true;
            classroomService.updateSubmissionReview(vm.profile, vm.profile.tenant, vm.classroomCode.sessionId, submission.id, {
                status : status,
                reviewNote : submission.reviewNoteDraft || ''
            }).then(function (updated) {
                var index = vm.submissions.indexOf(submission);
                updated.reviewNoteDraft = updated.reviewNote || '';
                if (index !== -1) {
                    vm.submissions[index] = updated;
                }
                addNotice(status === 'returned' ? '已退回学生作品并保存反馈。' : '已批阅学生作品并保存反馈。');
            }).catch(showError)
            .finally(function () {
                vm.reviewBusy[submission.id] = false;
            });
        };
    }
}());
